import { c as _c } from "react/compiler-runtime";
import { type ReactNode } from 'react';
import { Button, Disclosure, DisclosurePanel } from 'react-aria-components';
import { FaPlus } from 'react-icons/fa6';
import styles from './faq-item.module.scss';
interface FaqItemProps {
  children: ReactNode;
  id: string;
  title: string;
}
export default function FaqItem(props) {
  const $ = _c(11);
  const {
    children,
    id,
    title
  } = props;
  let t0;
  if ($[0] !== title) {
    t0 = <h3 className={styles.faqItem_title}>{title}</h3>;
    $[0] = title;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FaPlus className={styles.faqItem_icon} size={24} />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = <Button className={styles.faqItem_button} slot="trigger">{t0}{t1}</Button>;
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== children) {
    t3 = <DisclosurePanel className={styles.faqItem_content}>{children}</DisclosurePanel>;
    $[5] = children;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== id || $[8] !== t2 || $[9] !== t3) {
    t4 = <Disclosure className={styles.faqItem} id={id}>{t2}{t3}</Disclosure>;
    $[7] = id;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}